/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-vars */
import { createContext } from 'react';

const UserContext = createContext(null);

export default UserContext;